import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";
import { Table, Loader, Dimmer } from "semantic-ui-react";
import {
  getCustomerRecentAppointments,
  setIsLoadingOnRecentAppointment,
  clearCustomerRecentAppApiError
} from "../../../actions/customerRecentAppointment";
import RecentAppointmentTableCell from "./recentAppointmentTableCell/recentAppointmentTableCell";
import moment from "moment";
import { momentTimezone } from "../../../utils/momentTimezone";
import { updateGlobalErrorMessage } from "../../../actions/globalError";

const timezoneMoment = momentTimezone(moment);
@connect(mapStateToProps)
export default class CenterPanelCustomerRecentAppointment extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.appointmentStepData.selectedCustomer.id) {
      this.props.dispatch(
        getCustomerRecentAppointments(
          this.props.appointmentStepData.selectedCustomer.id
        )
      );
      this.props.dispatch(setIsLoadingOnRecentAppointment(true));
    }
  }

  componentDidUpdate = () => {
    if (this.props.apiErrorReasons) {
      const reasonObj = this.props.apiErrorReasons[0];
      let errorMsg = reasonObj.description;
      if (!errorMsg || errorMsg.length === 0) {
        errorMsg = window.APP.LANGUAGE.Errors.DefaultApiErrorMessage;
      }
      this.props.dispatch(updateGlobalErrorMessage({ message: errorMsg }));
      this.props.dispatch(clearCustomerRecentAppApiError());
    }
  };

  render() {
    let { currentBookingId } = this.props;
    let recentAppointmentList = null;
    if (
      this.props.customerRecentAppointments &&
      this.props.customerRecentAppointments.length > 0
    ) {
      //let sortedList = this.props.customerRecentAppointments.reverse();

      let sortedList = this.props.customerRecentAppointments.sort((a, b) => {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return moment(b.starttime) - moment(a.starttime);
      });

      recentAppointmentList = (
        <Table.Body className="recent_app">
          {sortedList
            .filter(x => x.id != currentBookingId)
            .map(booking => {
              const bookingDate = timezoneMoment.utc(booking.starttime);
              return (
                <RecentAppointmentTableCell
                  key={booking.id}
                  appointmentDate={bookingDate
                    .tz(this.props.appointmentStepData.timezone)
                    .format("MMMM DD, YYYY")}
                  appointmentServiceName={booking.servicename}
                  appointmentStaffName={booking.resourcename}
                  appointmentCancelled={
                    booking.status.id == 5 || booking.status.id == 6
                  }
                />
              );
            })}
        </Table.Body>
      );
    }
    return (
      <div className="tabpane recent-appointment-tab ">
        <Dimmer active={this.props.isLoading}>
          <Loader />
        </Dimmer>
        <Table basic="very">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="pdlxs">
                {
                  window.APP.LANGUAGE.Pages.CustomerRecentAppointment
                    .DateTableHeader
                }
              </Table.HeaderCell>
              <Table.HeaderCell>
                {
                  window.APP.LANGUAGE.Pages.CustomerRecentAppointment
                    .ServicesTableHeader
                }
              </Table.HeaderCell>
              <Table.HeaderCell>
                {
                  window.APP.LANGUAGE.Pages.CustomerRecentAppointment
                    .StaffTableHeader
                }
              </Table.HeaderCell>
              <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {recentAppointmentList}
        </Table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    customerRecentAppointments:
      state.customerRecentAppointmentsReducer.customerRecentAppointments,
    isLoading: state.customerRecentAppointmentsReducer.isLoading,
    currentBookingId: state.bookingReducer.currentBookingId,
    apiErrorReasons: state.customerRecentAppointmentsReducer.apiErrorReasons
  };
}
